export default __webpack_public_path__ + "652ad25d280b08f0592c7dfdbf2a27b1.png";